import { motion } from 'motion/react';
import { Link } from 'react-router';

/**
 * `react-router`'s `Link`, animatable — so a navigation that is also the
 * screen's primary action can carry the same press feedback as a button.
 *
 * At module scope on purpose: `motion.create` builds a component, and calling
 * it during a render would rebuild (and remount) it on every pass.
 */
export const MotionLink = motion.create(Link);
